import React, { useEffect, useState } from "react";
import * as func from "../../common/athleteCommon/FunctionCalls";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";

const ExternalPerformance = () => {

    const [performanceList, setPerformanceList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function fetchExternalPerformance() {
            setIsLoading(true);
            const externalPerformanceResponse = await func.externalPerformance(null);
            setPerformanceList(Array.isArray(externalPerformanceResponse) ? externalPerformanceResponse : [])
            setIsLoading(false);
        }
        fetchExternalPerformance();
    }, []);

    const filteredData = performanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const competitionRender = (rowData) => {
        return <span>{rowData.competitionName}</span>;
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const formatRender = (rowData) => {
        return <span>{rowData.formatedData}</span>;
    };

    const rankcompetitorCountRender = (rowData: any) => {
        return <span>{rowData.extComAthleterank} / {rowData.competitorscount}</span>;
    };

    const rankRender = (rowData) => {
        return <span>{rowData.extComAthleterank}</span>;
    };

    const performanceStatRender = (rowData) => {
        return <span>{rowData.extComAthletePerformanceStat}</span>;
    };

    const lastMeetAttemptsRender = (rowData: any) => {
        const attempts = rowData?.lastMeetAttempts;

        if (!attempts) {
            return <span>-</span>;
        }

        const renderAttemptCells = (
            type: "snatch" | "cleanAndJerk"
        ) => {
            return [1, 2, 3].map((num) => {
                const attempt = attempts?.[type]?.find(
                    (item: any) => item.attempt_num === num
                );

                return (
                    <td key={num}>
                        {attempt ? (
                            <>
                                {attempt.weight}{" "}
                                <span
                                    className={
                                        attempt.result
                                            ? "text-success"
                                            : "text-danger"
                                    }
                                >
                                    {attempt.result ? "✓" : "✗"}
                                </span>
                            </>
                        ) : (
                            "-"
                        )}
                    </td>
                );
            });
        };

        return (
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "flex-start",
                }}
            >
                {/* SNATCH TABLE */}
                <table
                    className="table table-bordered table-sm mb-0 text-center"
                    style={{
                        width: "220px",
                        minWidth: "220px",
                    }}
                >
                    <thead>
                        <tr>
                            <th colSpan={3}>SNATCH</th>
                        </tr>

                        <tr>
                            <th>1</th>
                            <th>2</th>
                            <th>3</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            {renderAttemptCells("snatch")}
                        </tr>
                    </tbody>
                </table>

                {/* CLEAN & JERK TABLE */}
                <table
                    className="table table-bordered table-sm mb-0 text-center"
                    style={{
                        width: "220px",
                        minWidth: "220px",
                    }}
                >
                    <thead>
                        <tr>
                            <th colSpan={3}>CLEAN &amp; JERK</th>
                        </tr>

                        <tr>
                            <th>1</th>
                            <th>2</th>
                            <th>3</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            {renderAttemptCells("cleanAndJerk")}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    const platformEffRender = (rowData) => {
        return <span>{rowData.platformEfficiency}</span>;
    };

    const weightRender = (rowData) => {
        return <span>{rowData.extComWeighInWeight}</span>;
    };

    const weightClassRender = (rowData) => {
        return <span>{rowData.extComWeightClass}</span>;
    };

    const sinclairCoeffRender = (rowData) => {
        return <span>{rowData.extComSinclairCoefficient}</span>;
    };

    const robiRender = (rowData) => {
        return <span>{rowData.extComRobiWorldRecordTotal}</span>;
    };

    const remarksRender = (rowData) => {
        return <span>{rowData.remarks}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == "1") ? "Pending" : (rowData.status == "2") ? "Completed" : "Disqualified"}</span>;
    };

    return (
        <>
        {isLoading && (
                    <div id="global-loader">
                        <div className="loader-img">
                            <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                        </div>
                    </div>
                )}
                    <div className="content container" style={{ maxWidth: "1500px" }}>
                        <div className="row">
                            <div className="sortby-section">
                                <div className="sorting-info">
                                    <div className="row col-lg-12 mb-10">
                                        <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                            <label>
                                                <input
                                                    type="text"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    style={{ height: "40px" }}
                                                    placeholder="Search"
                                                    className="form-control"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div className="tab-content">
                                        <div
                                            className="tab-pane fade show active"
                                            id="nav-Recent"
                                            role="tabpanel"
                                            aria-labelledby="nav-Recent-tab"
                                            tabIndex={0}
                                        >
                                            <div className="table-responsive table-datatble">
                                                <DataTable
                                                    className="table datatable"
                                                    value={filteredData}
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                    pageLinkSize={3}
                                                >
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="slNo"
                                                        body={slNoRender}
                                                        header="Sl &nbsp; No"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="extComEventName"
                                                        header="Competiton"
                                                        body={competitionRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="extComAthleteId"
                                                        header="Athlete"
                                                        body={athleteRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="competitorscount"
                                                        header="Rank/Competitors Count"
                                                        body={rankcompetitorCountRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="extComWeighInWeight"
                                                        header="Weight"
                                                        body={weightRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="extComWeightClass"
                                                        header="Weight Class"
                                                        body={weightClassRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="platformEfficiency"
                                                        header="Platform Efficiency"
                                                        body={platformEffRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="extComSinclairCoefficient"
                                                        header="Sinclair Coefficient"
                                                        body={sinclairCoeffRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="extComRobiWorldRecordTotal"
                                                        header="Robi World Record"
                                                        body={robiRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase text-center"
                                                        field="lastMeetAttempts"
                                                        header="Last Meet Attempts"
                                                        body={lastMeetAttemptsRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="remarks"
                                                        header="Remarks"
                                                        body={remarksRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                    <Column
                                                        sortable
                                                        headerClassName="text-uppercase"
                                                        field="status"
                                                        header="Status"
                                                        body={statusRender}
                                                        className="table-inset-btn"
                                                    ></Column>
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        </>
    );
};

export default ExternalPerformance;